module.exports = __webpack_public_path__ + "static/XLMCard-a7d80a571122002a45563fc794ad5d36.png";